import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';
import './ProcurementPlanningTabs.css';

const ProcurementPlanningTabs: React.FC = () => {
  const permissions = useAppSelector(state => state.auth.permissions);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <nav aria-label="Планування закупівель і забезпечення" className="order-supply-tabs">
      {permissions.includes('page.management.event-orders') &&
        <button type="button" aria-pressed={pathname === '/management/order-supply'}
          onClick={() => navigate('/management/order-supply')}>Забезпечення замовлень</button>}
      {permissions.includes('page.management.purchase-worksheet') &&
        <button type="button" aria-pressed={pathname === '/management/purchase-planning'}
          onClick={() => navigate('/management/purchase-planning')}>Прогноз закупівель</button>}
    </nav>
  );
};

export default ProcurementPlanningTabs;
